import React, { Component } from "react";
import { ExcelRenderer } from "react-excel-renderer";
import ReactTable from "react-table";
import axios from "axios";
import { PodSaveReq } from "../FacadesJson/PodSaveReq";
// import "../../assets/css/print.css";
// import "../../assets/css/loader.css";
import Select from "react-select";
//import { Select } from "react-inputs-validation";
import "../assets/css/print.css";
import "../assets/css/loader.css";

import swal from "sweetalert";
import HmacSHA256 from "crypto-js/hmac-sha256";
import { CSVLink } from "react-csv";
//import LoadingSpinner from "../../components/Input/LoadingSpinner";
import LoadingSpinner from "../components/Input/LoadingSpinner";
import $ from "jquery";
//import "../../../src/assets/css/loader.css";

const kodePershkrimi = [
    { value: "1", label: "Reminder" },
    { value: "2", label: "SMS" },
  ];

class SendSMSList extends Component {
  state = {
    rows1: [],
    rapFacade: [],
    kodSherbimiP: "",
    kodSherbimiDK: "",
    statusi: [],
    podi: [],
    cmimi: [],
    Token: "",
    Username: "",
    error1: "",
    kodiPershkrimit: { value: "1", label: "Reminder" },
    kodproduktoptions: kodePershkrimi,
    showModal: false,
    loading: false,
    postsexcel: []
  };

  showModal = () => {
    this.setState({ showModal: true });
  };
  hideModal = () => {
    this.setState({ showModal: false });
  };

  onClearInput = () => {
    // this.setState({
    //   rows1: [],
    //   rapFacade: [],
    //   error1: "",
    //   showModal: false,
    //   loading: false,
    //   rows: [],
    // });
    window.location.reload();
  };
  handleClickModal = (e) => {
    var posts = [...this.state.posts];
    posts.push(this.state.njesi);
    this.setState({ posts: posts, cope: posts.length + 1 });
  };

  convert = (par) => {
    par.forEach((element) => {
    if (element[1]!= "" && element[1]!= undefined)
    {
        var rowPost = new PodSaveReq();

        rowPost.PODNr = element[1]
        .toString()
        .toUpperCase()
        .trim();
      
        rowPost.AgjensiDestinacion = element[5].toString().trim();

        rowPost.Komente = this.state.kodiPershkrimit.label;

        //rowPost.KlientSubjektID = window.UserP.ClientSubjectID;

        // rowPost.Token = HmacSHA256(
        //     Math.round(new Date().getTime / 1000).toString(),
        //     window.UserP.key
        // ).toString();
      
        // rowPost.username = window.UserP.username;
      
        this.state.rapFacade.push(rowPost);
    }
    element++;
    });

    this.setState({ rapFacade: this.state.rapFacade });

    console.log(this.state.rapFacade);
  };

  onChangeFunc = (name) => (value) => {
    this.setState({
      [name]: value,
    });
    if(name=="marresi"){
      try{
      this.state.marresi=value.value;
      this.handleModalChange();
      }catch{
        this.state.marresi="";
      }
    }
  };

  handleClick = (e) => {
    if (this.state.rows == undefined) {
      swal("Ju lutem zgjidhni filen excel qe doni te ngarkoni!");
    } else {
      this.convert(this.state.rows);
       
      var postsnew = [];
      postsnew= this.state.rapFacade
      

      const req = {
        array: postsnew,
        Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
        Username: window.UserP.username,
      }

      $("cover-spin").show();
      this.setState({ loading: true }, () => {
        axios
          .post(window.UserP.url + "POD/SendWhatsappList", req)
          .then((response) => {
            for (var i in response.data) {
              let statusi = response.data[i].ResultMessage;
              let res = response.data[i].Result;

              if (res == true)
              {
                statusi = "Mesazhi u dergua me sukses";
              }
              this.state.statusi.push(statusi);

              const dataexcel = {
                POD: response.data[i].ResultMessageCheck,
                Agjensia_Destinacion: response.data[i].ResultMessageTotali,
                Mesazhi: statusi
              }

              this.state.postsexcel.push(dataexcel);
             
            }

            this.setState({
                    loading: false,
                    postsexcel: this.state.postsexcel
                  });

            //if (this.state.podi.length == 0) {
            //   this.setState({
            //     loading: false,
            //     showModal: true,
            //     error1: "Mesazhet u derguan!",
            //   });
            //} else {
            //   this.setState({
            //     loading: false,
            //     showModal: true,
            //     error1:
            //       "Gabim! Podet e meposhtme nuk jane modifikuar." +
            //       this.state.podi,
            //   });
            // }
          })
          .catch((error) => {
            alert(error + " Ju lutem kontaktoni departamentin e IT!");
          });
      });
      return this.state.statusi;
    }
  };

  remove(array, element) {
    return array.filter((el) => el.length != element);
  }


  fileHandler = (event) => {
    //  console.log(this.state.rapFacade);

    let fileObj = event.target.files[0];

    //just pass the fileObj as parameter
    ExcelRenderer(fileObj, (err, resp) => {
      if (err) {
      } else {
        
        var res = this.remove(resp.rows, 0);
         
        var col = [];
        col.push(resp.cols[0]);
        col.push(resp.cols[1]);
        col.push(resp.cols[5]);
        
        res.shift();
        
        //console.log(col);

        this.setState({
          //cols: resp.cols,
          cols: col,
          rows: res,
        });

      }
    });

  
  };

  render() {
    const columns = [
      {
        Header: "Nr",
        accessor: "0",
        width: 100
      },
      {
        Header: "POD",
        accessor: "1",
        width: 400
      },
      {
        Header: "Agjensia Destinacion",
        accessor: "5",
        width: 200
      },
      {
        Header: "Mesazh",
        accessor: "6",
        width: 800,
        Cell: (statusi) => (
          <span className="number">{this.state.statusi[statusi.index]}</span>
        ),
      },
    ];

    return (
      <div className="card card-body bg-light col-md-12">
        <div className="row">
       <div className="col-md-3">
                         
                         <Select
                           id="4"
                           className="custom-Select"
                           onChange={this.onChangeFunc("kodiPershkrimit")}
                           options={this.state.kodproduktoptions}
                           value={this.state.kodiPershkrimit}
                           required
                         />
                     
                       </div>
         <div className="col-md-4">
          <input
            type="file"
            className="btn btn-default"
            onChange={this.fileHandler.bind(this)}
            style={{ padding: "10px" }}
          />
          </div>
        </div>
        
        <div>
          {this.state.loading ? (
            <LoadingSpinner />
          ) : (
            <ReactTable
              columns={columns}
              data={this.state.rows}
              defaultPageSize={10}
              className="-striped -highlight mt-4"
              pageText="Faqe"
              nextText="Para"
              rowsText="Rreshta"
              previousText="Mbrapa"
              noDataText="Nuk ka te dhena"
            />
          )}
        </div>

        <div className="row">
          <div className="ml-4">
            <button
              className="btn btn-primary mt-4"
              disabled={this.state.loading}
              onClick={(e) => this.handleClick(e)}
            >
              <span data-notify="icon" className="pe-7s-diskette" />
              &nbsp; Ruaj
            </button>
          </div>
          <div>
            {this.state.showModal ? (
              <div>
                <ModalTSh
                  showModal={this.state.showModal}
                  handleClose={this.hideModal}
                  className="modal fade docs-example-modal-sm"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="mySmallModalLabel"
                  aria-hidden="true"
                >
                  <div className="row">
                    <div className="col-md-9 ml-auto">{this.state.error1}</div>
                  </div>
                </ModalTSh>
              </div>
            ) : null}
          </div>
          <div className="mt-4">
            <CSVLink className="ml-4" data={this.state.postsexcel}>
              <span data-notify="icon" className="pe-7s-download" />
              &nbsp; Eksporto
            </CSVLink>
          </div>
          <div className="col md-6 mt-4">
            <button
              className="btn btn-primary float-right"
              onClick={() => this.onClearInput()}
            >
              <span data-notify="icon" className="pe-7s-trash" />
              &nbsp; Pastro
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export const ModalTSh = ({ handleClose, showModal, children }) => {
  const showHideClassName = showModal
    ? "modal display-block"
    : "modal display-none";

  return (
    <div className={showHideClassName}>
      <section className="modal-main">
        {children}
        <button className="btn btn-primary btn-sm m-2" onClick={handleClose}>
          MByll
        </button>
      </section>
    </div>
  );
};
export default SendSMSList;
